// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__GO5Ej","skeletonLoadingAnimation":"Skeleton_skeletonLoadingAnimation__4S8SM"};